export default {

    data(){

        return {

            noemailtext : 'noemail.careexchange.com'
        }
    },

    methods: {

        checkForNoEmailDomain() {

            if( this.form.email ){

                if( this.isEmptyEmail( this.form.email ) ){

                    this.form.no_email = true;
                    this.form.email    = null;
                }
            }
        },

        isEmptyEmail( email ){

            return email.substr( this.noemailtext.length * -1 ) === this.noemailtext;
        },

        formatEmail( value ){

            if( !value || value.toString().includes( this.noemailtext ) ) return '';

            return value;
        },
        formatRoleType( value ){

            if( value === 'office_user' ) return 'LTCG User';
            if( value === 'client'      ) return 'Claimant';
            if( value === 'caregiver'   ) return 'Provider';
            return value;
        },
    }
}
